
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry-leader/universities",
      function () {
        return require("private-next-pages/industry-leader/universities/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry-leader/universities"])
      });
    }
  